import { render, staticRenderFns } from "./nine2.vue?vue&type=template&id=1180b016&scoped=true"
import script from "./nine2.vue?vue&type=script&lang=js"
export * from "./nine2.vue?vue&type=script&lang=js"
import style0 from "./nine2.vue?vue&type=style&index=0&id=1180b016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180b016",
  null
  
)

export default component.exports